// Mock data for Unshackled Living Podcast Website

export const siteConfig = {
  name: "Unshackled Living",
  tagline: "Live Free, Stay Sovereign",
  description: "The podcast for those ready to reclaim control of their lives—financially, physically, digitally, and spiritually.",
  heroSubtext: "Each episode explores what it truly means to live free in a world built on dependence. From Bitcoin and self-custody to food independence, off-grid energy, ancestral health, and digital privacy—this is your roadmap to sovereignty in the 21st century.",
  mission: "Help you exit centralized systems and build resilient, self-reliant lives through knowledge, tools, and community."
};

export const hostInfo = {
  name: "Jarrett",
  title: "Host & Educator",
  image: "/images/ash-scaled.jpg",
  bio: [
    "Jarrett is an Adjunct Professor at the University of British Columbia's Sauder School of Business, where he teaches marketing through the lens of sound money, incentives, and real world economics. He has been studying and using Bitcoin since 2017, and today focuses his work on financial sovereignty, Bitcoin education, and building parallel systems that last.",
    "Outside the classroom, Jarrett lives the principles he teaches. He runs an urban farm with chickens, honeybees, and a year round garden. He hunts and fishes, heats his home with salvaged urban firewood, and builds furniture from reclaimed materials. His goal is simple and deliberate independence over food, energy, and money.",
    "A devoted husband and father of three, Jarrett teaches his children about Bitcoin the same way past generations learned about work and value through hands on experience, including running a neighborhood lemonade stand and saving in bitcoin.",
    "His life and work are grounded in one main idea: sovereignty is built daily through responsibility, skill, and opting out of systems that no longer serve us."
  ],
  images: [
    "/images/thumb_IMG_3026.jpeg",
    "/images/thumb_IMG_3027.jpeg",
    "/images/thumb_IMG_3029.jpeg"
  ]
};

export const coreTopics = [
  {
    id: 1,
    title: "Financial Sovereignty",
    subtitle: "Bitcoin & Self-Custody",
    description: "Take control of your wealth. Learn about Bitcoin, self-custody, and breaking free from the debt-based financial system.",
    icon: "Wallet"
  },
  {
    id: 2,
    title: "Food Independence",
    subtitle: "Permaculture & Homesteading",
    description: "Grow your own food, raise animals, and build systems that provide nutritious sustenance for your family year-round.",
    icon: "Sprout"
  },
  {
    id: 3,
    title: "Health Autonomy",
    subtitle: "Ancestral Well-being",
    description: "Reclaim your health through ancestral practices, natural remedies, and freedom from pharmaceutical dependence.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Sovereign Education",
    subtitle: "Raising Free Thinkers",
    description: "Explore homeschooling, unschooling, and alternative education to raise truly autonomous humans.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Digital Privacy",
    subtitle: "Open-Source Freedom",
    description: "Protect your digital life with privacy tools, decentralized platforms, and open-source alternatives.",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Off-Grid Energy",
    subtitle: "Energy Independence",
    description: "Solar, wind, and alternative energy solutions to break free from centralized power grids.",
    icon: "Sun"
  }
];

export const featuredEpisodes = [
  {
    id: 1,
    title: "The Sovereign Child: Raising Truly Autonomous Humans",
    description: "Rewriting the rules of freedom and what it means to raise children who think for themselves.",
    duration: "53:52",
    date: "5 days ago",
    views: "300",
    youtubeUrl: "https://www.youtube.com/watch?v=BiJ3ovDM6Vk",
    thumbnail: "https://i.ytimg.com/vi/BiJ3ovDM6Vk/maxresdefault.jpg"
  },
  {
    id: 2,
    title: "Bitcoin, Free Speech and the Next Internet: Damus and Decentralized Social Media",
    description: "Exploring the future of decentralized social media and its implications for free speech.",
    duration: "58:45",
    date: "1 month ago",
    views: "60",
    youtubeUrl: "https://www.youtube.com/watch?v=Y6xL9F-DzRk",
    thumbnail: "https://i.ytimg.com/vi/Y6xL9F-DzRk/maxresdefault.jpg"
  },
  {
    id: 3,
    title: "Bitcoin, Gold, and the Next 1000 Years of Money",
    description: "From Fiat Failure to the Bitcoin Standard - understanding the future of sound money.",
    duration: "50:49",
    date: "1 month ago",
    views: "55",
    youtubeUrl: "https://www.youtube.com/watch?v=Yo39jUVGC9M",
    thumbnail: "https://i.ytimg.com/vi/Yo39jUVGC9M/maxresdefault.jpg"
  },
  {
    id: 4,
    title: "Bitcoin, the Bible, and Sound Money with Pastor Coin",
    description: "Exploring the intersection of faith, financial sovereignty, and Bitcoin.",
    duration: "49:21",
    date: "1 month ago",
    views: "215",
    youtubeUrl: "https://www.youtube.com/watch?v=UD1uEZflTzU",
    thumbnail: "https://i.ytimg.com/vi/UD1uEZflTzU/maxresdefault.jpg"
  },
  {
    id: 5,
    title: "Deflation, Bitcoin, and the Future of Money with Jeff Booth",
    description: "Exploring economic transformation and Bitcoin's potential as a deflationary asset.",
    duration: "59:00",
    date: "1 year ago",
    views: "14,779",
    youtubeUrl: "https://www.youtube.com/watch?v=9LMPuyJKv_s",
    thumbnail: "https://i.ytimg.com/vi/9LMPuyJKv_s/maxresdefault.jpg"
  },
  {
    id: 6,
    title: "Inside LayerZero: Bryan Pellegrino on Poker, Protocols, and Web3",
    description: "A deep dive into the future of blockchain interoperability and Web3 protocols.",
    duration: "52:33",
    date: "2 months ago",
    views: "207",
    youtubeUrl: "https://www.youtube.com/watch?v=irboGVJe9MI",
    thumbnail: "https://i.ytimg.com/vi/irboGVJe9MI/maxresdefault.jpg"
  }
];

export const podcastPlatforms = [
  {
    name: "YouTube",
    url: "https://www.youtube.com/@UnshackledLiving",
    icon: "Youtube"
  },
  {
    name: "Spotify",
    url: "https://open.spotify.com/show/1PtMZz4l4OkdzTzsQoCJWu",
    icon: "Music"
  },
  {
    name: "Apple Podcasts",
    url: "https://podcasts.apple.com/us/podcast/the-web3-prof/id1655775546",
    icon: "Apple"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is Unshackled Living about?",
    answer: "Unshackled Living is a podcast exploring what it truly means to live free in a world built on dependence. We cover financial sovereignty through Bitcoin, food independence, health autonomy, alternative education, digital privacy, and sustainable living."
  },
  {
    id: 2,
    question: "How often are new episodes released?",
    answer: "We release new episodes weekly, featuring in-depth conversations with thought leaders, practitioners, and pioneers in the sovereignty movement."
  },
  {
    id: 3,
    question: "Where can I listen to the podcast?",
    answer: "You can listen on YouTube, Spotify, Apple Podcasts, and most major podcast platforms. Subscribe to stay updated with new episodes."
  },
  {
    id: 4,
    question: "Can I suggest a topic or guest?",
    answer: "Absolutely! We love hearing from our community. Reach out through our newsletter or social channels with your suggestions."
  },
  {
    id: 5,
    question: "Is the content suitable for beginners?",
    answer: "Yes! While we dive deep into various topics, we make sure our content is accessible to anyone beginning their sovereignty journey, regardless of their starting point."
  }
];

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Topics", href: "#topics" },
  { name: "Episodes", href: "#episodes" },
  { name: "FAQ", href: "#faq" },
  { name: "Courses", href: "#courses" }
];
